export const getTotalPrice = (products: { grossPricePerUnit: number; quantity: number }[]): number =>
  products.reduce((sum, product) => sum + product.grossPricePerUnit * product.quantity, 0) / 100;
